import { usePageDataStore } from '~/stores/pageStore';
import { addToHistory, type PageHistoryEntryInterface } from '~/composables/usePageHistoryStorage';
import { watch } from 'vue';

export default defineNuxtPlugin(nuxtApp => {
    const router = nuxtApp.$router;
    // @ts-ignore
    watch(
        () => router.currentRoute.value,
        (to, from) => {
            const pageDataStore = usePageDataStore();

            let pageHistoryEntry: PageHistoryEntryInterface = {
                key: to.path,
                url: to.fullPath,
                type: pageDataStore?.getData?.type ?? 'page',
                priority: 1,
            };
            addToHistory(pageHistoryEntry);
        },
        { immediate: true },
    );
});
